import { langIdOnLocale } from '../LocaleUtil/languageList';
import { PosList, POS } from './constants';

const toCanonicalLocale = (locale = '') => {
    const sep = locale.indexOf('_') === -1 ? '-' : '_';
    const [lang, region] = locale.split(sep);
    return region ? `${lang.toLowerCase()}_${region.toUpperCase()}` : locale;
};

export const DEFAULT_POS = PosList.find((pos) => pos.name === POS.NONE);

export const findBySiteId = (siteid) => PosList.find((pos) => String(pos.siteid) === String(siteid));
export const findByTpidEapid = (tpid, eapid = 0) => PosList.find(
    (pos) => String(pos.tpid) === String(tpid)
        && String(pos.eapid) === String(eapid)
);
export const findBySiteIdLangId = (siteid, langid) => PosList.find(
    (pos) => String(pos.siteid) === String(siteid)
        && String(pos.langid) === String(langid)
);
export const findByLangId = (langid) => PosList.find(
    (pos) => String(pos.langid) === String(langid)
);
export const findByLocale = (locale) => {
    switch (locale) {
    case 'en_AU':
        return PosList.find((pos) => pos.name === POS.AUSTRALIA);
    case 'en_NZ':
        return PosList.find((pos) => pos.name === POS.NEW_ZEALAND);
    default:
        return findByLangId(langIdOnLocale(locale)) || PosList[0];
    }
};
export const findByTpid = (tpid) => PosList.find(
    (pos) => String(pos.tpid) === String(tpid)
        && String(pos.eapid) === '0'
);

export const findByUtmSource = (utmSource) => {
    /**
     * utmSource might be a comma separated list or array if there was more than one query param
     * depending on how it was called (from server side of client side). We should handle both cases
     * as well as just a single utm source as a string
     *  */
    if (!utmSource) return;
    const utmArray = [];

    if (Array.isArray(utmSource)) {
        // It's already an array
        utmArray.push(...utmSource);
    } else if (utmSource.indexOf(',') !== -1) {
        // It's a comma separated list, turn it into an array
        utmArray.push(...utmSource.split(','));
    } else {
        // It's a single string
        utmArray.push(utmSource);
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const utm of utmArray) {
        // Loop through the utm sources until we find a match, then return it
        const result = PosList.find((pos) => pos.utmSource && String(pos.utmSource) === String(utm));
        if (result) {
            // eslint-disable-next-line consistent-return
            return result;
        }
    }
};

export const findPos = (siteData = {}, locale = '') => {
    const {
        tpid, eapid, siteid, langid, utmSource
    } = siteData;
    let pos = findBySiteIdLangId(siteid, langid) || findBySiteId(siteid)
        || findByTpidEapid(tpid, eapid) || findByTpid(tpid)
        || findByUtmSource(utmSource) || DEFAULT_POS;
    if (pos.name === DEFAULT_POS.name && locale) {
        pos = findByLangId(langIdOnLocale(locale)) || pos;
    }
    return pos;
};

export const findPosFromQueryParams = (queryParams) => {
    const {
        // eslint-disable-next-line camelcase
        siteid, tpid, eapid, langid, utm_source
    } = queryParams;
    return findPos({
        siteid,
        tpid,
        eapid,
        langid,
        utmSource: utm_source
    });
};

export const findPosFromRequest = (request) => {
    let pos = findPosFromQueryParams(request.query);
    if (pos.name === POS.NONE) {
        pos = findByLangId(langIdOnLocale(toCanonicalLocale(request.params.locale))) || pos;
    }
    return pos;
};

export default {
    findBySiteId,
    findByTpidEapid,
    findByTpid,
    findBySiteIdLangId,
    findPos,
    findPosFromQueryParams,
    findByLangId,
    DEFAULT_POS
};
